.link {
  color: var(--color-text-link);

  &:hover {
    color: var(--color-text-link-hover);
    text-decoration: underline;
    cursor: pointer;
  }
}
